/* Feevra - Partner-Ads cart bridge (2026-09-23)
 *
 * HVORFOR DEN FINDES
 * Partner-Ads' eget script (partnertrackshopify.dk/js/register.js) gemmer
 * partner-id og klik-id i localStorage + cookie som "x-pa-id" / "x-pa-pacid".
 * Derefter forsoeger det at haenge dem paa kurven ved at indsaette skjulte
 * <input name="properties[_x-pa-id]"> i en <form action="/cart/add">.
 *
 * Feevras tema har ingen saadan formular. Vi laegger i kurven med
 *   fetch('/cart/add.js', { body: JSON.stringify({items:[...]}) })
 * (snippets/product-form.liquid, feevra-cart-drawer.liquid m.fl.), og et
 * JSON-kald laeser aldrig skjulte input-felter. Derfor naaede _x-pa-id og
 * _x-pa-pacid aldrig ind i kurven, og Partner-Ads kunne ikke bogfoere salget.
 *
 * HVAD DEN GOER
 *   1) Wrapper window.fetch og injicerer de to properties i ALLE /cart/add-kald,
 *      uanset hvilken knap eller hvilket snippet der udloeser dem.
 *   2) Saetter samme vaerdier som cart attributes via /cart/update.js, saa de
 *      ogsaa foelger med hvis en anden vej lagde varen i kurven.
 *
 * SIKKERHED
 * Alt er pakket i try/catch. Fejler noget som helst, sendes det oprindelige
 * kald videre uroert - et kurvkald maa ALDRIG blokeres af denne fil.
 * Properties med understreg-praefiks er skjulte i Shopify og vises ikke for
 * kunden; cart-draweren laeser kun _display_title, saa der er ingen visuel
 * paavirkning.
 */
(function () {
  'use strict';

  if (window.__feevraPartnerAds) return;
  window.__feevraPartnerAds = true;

  var KEY_ID = 'x-pa-id';
  var KEY_PACID = 'x-pa-pacid';
  var KEY_START = 'x-pa-startTime';
  var WINDOW_MS = 40 * 24 * 60 * 60 * 1000; // Partner-Ads' cookie-levetid: 40 dage

  function fromCookie(name) {
    try {
      var esc = name.replace(/[-.*+?^${}()|[\]\\]/g, '\\$&');
      var m = document.cookie.match(new RegExp('(?:^|;\\s*)' + esc + '=([^;]*)'));
      return m ? decodeURIComponent(m[1]) : null;
    } catch (e) { return null; }
  }

  function read(name) {
    try {
      var v = window.localStorage.getItem(name);
      if (v) return v;
    } catch (e) { /* localStorage kan vaere blokeret */ }
    return fromCookie(name);
  }

  /* Returnerer {id, pacid} hvis der findes et gyldigt, ikke-udloebet klik. */
  function creds() {
    try {
      var id = read(KEY_ID);
      var pacid = read(KEY_PACID);
      if (!id || !pacid) return null;

      var start = read(KEY_START);
      if (start) {
        var t = parseInt(start, 10);
        if (!isNaN(t) && (Date.now() - t) > WINDOW_MS) return null; // klikket er for gammelt
      }
      return { id: id, pacid: pacid };
    } catch (e) { return null; }
  }

  var originalFetch = window.fetch ? window.fetch.bind(window) : null;

  /* ---------- 1) Injicér properties i alle /cart/add-kald ---------- */

  if (originalFetch) {
    window.fetch = function (input, init) {
      try {
        var url = (typeof input === 'string')
          ? input
          : (input && input.url) || '';

        if (url.indexOf('/cart/add') !== -1 && init && init.body) {
          var c = creds();
          if (c) {
            if (typeof init.body === 'string') {
              // JSON-payload (den vej Feevras tema bruger)
              var payload = JSON.parse(init.body);
              var stamp = function (item) {
                item.properties = item.properties || {};
                item.properties['_x-pa-id'] = c.id;
                item.properties['_x-pa-pacid'] = c.pacid;
                return item;
              };
              if (Object.prototype.toString.call(payload.items) === '[object Array]') {
                payload.items = payload.items.map(stamp);
              } else if (payload.id) {
                stamp(payload);
              }
              init = Object.assign({}, init, { body: JSON.stringify(payload) });
            } else if (typeof FormData !== 'undefined' && init.body instanceof FormData) {
              // FormData-payload (assets/product-form.js)
              if (!init.body.has('properties[_x-pa-id]')) {
                init.body.append('properties[_x-pa-id]', c.id);
                init.body.append('properties[_x-pa-pacid]', c.pacid);
              }
            }
          }
        }
      } catch (e) {
        // Bevidst tom: et kurvkald maa aldrig fejle paa grund af tracking.
      }
      return originalFetch(input, init);
    };
  }

  /* ---------- 2) Saet samme vaerdier som cart attributes ---------- */

  var syncing = false;

  function syncAttributes() {
    if (syncing || !originalFetch) return;
    var c = creds();
    if (!c) return;
    syncing = true;

    originalFetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var a = (cart && cart.attributes) || {};
        if (a[KEY_ID] === c.id && a[KEY_PACID] === c.pacid) return null; // allerede sat
        var attrs = {};
        attrs[KEY_ID] = c.id;
        attrs[KEY_PACID] = c.pacid;
        return originalFetch('/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ attributes: attrs })
        });
      })
      .catch(function () { /* stille */ })
      .then(function () { syncing = false; }, function () { syncing = false; });
  }

  function boot() {
    syncAttributes();
    // register.js saetter cookien ved page load; koer en gang mere bagefter
    // saa vi ikke rammer foer den er skrevet paa selve landingsklikket.
    setTimeout(syncAttributes, 1500);
  }

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    boot();
  } else {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  }

  document.addEventListener('cart:updated', function () { setTimeout(syncAttributes, 300); });
})();
